import {registerBrick} from 'olympe';
import {ReactBrick, useProperty} from '@olympeio/core';
import React, {useEffect, useState} from 'react';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import CircularProgress from '@mui/material/CircularProgress';

export default class SwaggerUIBrick extends ReactBrick {
    static getReactComponent($) {
        return (props) => {
            const height = useProperty($, 'Height', true);
            const [swaggerFile, setSwaggerFile] = useState('');
            const swaggerFileProperty = useProperty($, 'Swagger file', true);
            const useSwaggerFileInProperty = useProperty($, 'Use swagger file in property', true);

            useEffect(() => {
                fetch('res/swagger_file.yaml')
                    .then((response) => {
                        response.text()
                            .then((text) => {
                                setSwaggerFile(text);
                            });
                    });
            }, []);

            return swaggerFile ? (
                <div style={{overflow: 'scroll', height: `${height}px`}}>
                    <SwaggerUI spec={useSwaggerFileInProperty ? swaggerFileProperty : swaggerFile}/>
                </div>
            ) : (
                <CircularProgress size={40}/>
            );
        };
    }
}

registerBrick('018f9ba0fa5a83bcbd68', SwaggerUIBrick);
